import loggingService from '../services/util/loggingService'

var serviceName = 'groupService'
var path = '/Lookup/Role/'
var isDebug = false

const RoleEnum = {
    Administrator: 'Administrator',
    BlmUser: 'Agency User',
    AgencyNoReview: 'Agency No Review',
    ConsultantUser: 'Consultant User',
    ShpoAdministrator: 'SHPO Administrator',
    ShpoCrApprovingUser: 'SHPO CR Approving User',
    ShpoCrDataEntryUser: 'SHPO CR Data Entry User',
    ShpoRcAdministrator: 'SHPO RC Administrator',
    ShpoRcApprovingUser: 'SHPO RC Approving User',
    ShpoRcDataEntryUser: 'SHPO RC Data Entry User',
    CLGConsultant: 'CLG Consultant',
    E106User: 'E106 User',
    ClientUser: 'Client User',
    PublicUser: 'Public User',
    TribalAffiliate: 'Tribal Affiliate'
}

const ShpoRoleList = [
    RoleEnum.Administrator,
    RoleEnum.ShpoAdministrator,
    RoleEnum.ShpoCrApprovingUser,
    RoleEnum.ShpoCrDataEntryUser,
    RoleEnum.ShpoRcAdministrator,
    RoleEnum.ShpoRcApprovingUser,
    RoleEnum.ShpoRcDataEntryUser
]

const ShpoCrRoleList = [
    RoleEnum.Administrator,
    RoleEnum.ShpoAdministrator,
    RoleEnum.ShpoCrApprovingUser,
    RoleEnum.ShpoCrDataEntryUser
]

const ShpoRcRoleList = [
    RoleEnum.Administrator,
    RoleEnum.ShpoAdministrator,
    RoleEnum.ShpoRcAdministrator,
    RoleEnum.ShpoRcApprovingUser
]

const ShpoReadOnlyRoleList = [
    RoleEnum.ShpoCrApprovingUser,
    RoleEnum.ShpoCrDataEntryUser
]

const ConsultantRoleList = [
    RoleEnum.Administrator,
    RoleEnum.ShpoAdministrator,
    RoleEnum.ConsultantUser
]

const AgencyRoleList = [
    RoleEnum.Administrator,
    RoleEnum.ShpoAdministrator,
    RoleEnum.BlmUser
]

const AdminRoleList = [
    RoleEnum.Administrator,
    RoleEnum.ShpoRcAdministrator,
    RoleEnum.ShpoAdministrator
]

const ConsultantOnlyRoleList = [
    RoleEnum.ConsultantUser,
    RoleEnum.CLGConsultant,
    RoleEnum.E106User,
    RoleEnum.ClientUser
]

const AgencyViewOnlyRoleList = [
    RoleEnum.AgencyNoReview
]

const ViewOnlyRoleList = [
    RoleEnum.AgencyNoReview,
    RoleEnum.ClientUser,
    RoleEnum.TribalAffiliate
]

const AllRolesExceptPublic = [
    RoleEnum.Administrator,
    RoleEnum.BlmUser,
    RoleEnum.AgencyNoReview,
    RoleEnum.ConsultantUser,
    RoleEnum.ShpoAdministrator,
    RoleEnum.ShpoCrApprovingUser,
    RoleEnum.ShpoCrDataEntryUser,
    RoleEnum.ShpoRcAdministrator,
    RoleEnum.ShpoRcApprovingUser,
    RoleEnum.ShpoRcDataEntryUser,
    RoleEnum.CLGConsultant,
    RoleEnum.E106User,
    RoleEnum.ClientUser,
    RoleEnum.TribalAffiliate
]

const RestrictedRoleList = [
    RoleEnum.AgencyNoReview,
    RoleEnum.TribalAffiliate
]

function list (http) {
    loggingService.log(isDebug, serviceName, 'list')

    return http.get(path + 'List')
}

export default {
    RoleEnum: RoleEnum,
    ShpoRoleList: ShpoRoleList,
    ShpoReadOnlyRoleList: ShpoReadOnlyRoleList,
    ConsultantRoleList: ConsultantRoleList,
    AdminRoleList: AdminRoleList,
    list: list,
    ConsultantOnlyRoleList: ConsultantOnlyRoleList,
    AgencyRoleList: AgencyRoleList,
    ShpoCrRoleList: ShpoCrRoleList,
    ShpoRcRoleList: ShpoRcRoleList,
    AgencyViewOnlyRoleList: AgencyViewOnlyRoleList,
    ViewOnlyRoleList: ViewOnlyRoleList,
    AllRolesExceptPublic: AllRolesExceptPublic,
    RestrictedRoleList: RestrictedRoleList
}



// WEBPACK FOOTER //
// ./src/services/roleService.js